import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import ContactUsButton from "../../Components/Button/ContactUsButton";

import Authenticated from 'Components/Layouts/Authenticated';
import PageHeader from "Components/Utilities/PageHeader";
import Section from "Components/Utilities/Section";
import CmsElement from "Components/Utilities/CmsElement";
import {Loading} from "Components/Partials";
import {RenderWYSIWYG} from "Components/Form";
import {MailLink} from "Components/Utilities";

import {getRecordValue} from "Services/CmsHelpers";

export default class FAQ extends CmsElement {
    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'faq';

    /**
     * @var paginate
     * @type {boolean}
     */
    paginate = false;

    /**
     * @var allowUpdate
     * @type {boolean}
     */
    allowUpdate = false;

    /**
     * @var state
     */
    state = {
        working: true,
    };

    render () {
        const { working, records } = this.state;

        return (
            <Authenticated title="Dashboard">
                <PageHeader
                   title={"FAQs"}
                   imgSrc={'faq.png'}
                />

                {this.renderOpeningTextSection()}

                {working && <Loading />}

                {!working && this.renderFAQSection(records)}
                <Section>
                    <p className={"bmw-condenced-bold text-2xl"}>
                        QUESTIONS?
                    </p>
                    <p className={"bmw-condenced-bold text-sm pb-4"}>
                        If you have any questions please visit
                        {" "}
                        <MailLink to={"info@BMWUKretailerconvention2023.com"}>info@BMWUKretailerconvention2023.com</MailLink>
                    </p>
                    <a
                        href={`mailto:info@BMWUKretailerconvention2023.com`}
                        className="pt-4"
                    >
                        <ContactUsButton text={"Contact Us"}></ContactUsButton>
                    </a>
                </Section>
            </Authenticated>
        );
    }

    renderOpeningTextSection () {
        return (
            <Section>
                <p className={"bmw-condenced-bold text-2xl"}>
                    YOUR QUESTIONS ANSWERED
                </p>
                <p className={"bmw-condenced-bold"}>
                    Take a look at our FAQs below for key information about the BMW Group UK Retailer Convention 2023 in Cape Town, South Africa.
                </p>
            </Section>
        );
    }

    renderFAQSection (records) {
        return (
            <Section>
                <section className="grid grid-cols-1 gap-y-3 divide-y border-t-1 border-gray-200 ">
                    {records.data?.map((item) => (
                        <details className="group py-1 text-md p-5 text-left" key={item.id}>
                            <summary className="flex cursor-pointer uppercase flex-row item-left justify-between py-1 marker:[font-size:0px] bmw-bold p-5">
                                {getRecordValue(item, 'question')}
                                <FontAwesomeIcon icon={faChevronDown} />
                            </summary>

                            <p className=" bmw-light text-left text-sm p-5">
                                <RenderWYSIWYG content={getRecordValue(item, 'answer')} />
                            </p>
                        </details>
                    ))}
                </section>
            </Section>
        );
    }
}
